/** The forms step piece, standard look over its behavior half. */
import { FormsStepView } from './FormsStepView';
import { useFormsStep, type FormsStepInput } from './useFormsStep';

export function FormsStep(props: FormsStepInput) {
  return <FormsStepView {...useFormsStep(props)} />;
}
